import { mkSiteBuilderComponent } from "@discovery/template-engine/lib/component-map";
import { RenderMaybe } from "@discovery/components-luna-react/lib/utils/render-maybe";
import { Fold } from "@discovery/prelude/lib/control/lens";
import * as M from "@discovery/prelude/lib/data/maybe";
import { Link } from "../../components/atoms/link";
import { SonicImageDplus } from "../../components/atoms/sonic-image";
import { _DesktopBanner, _MobileBanner, _BannerLink } from "./optics";
import * as styles from "./styles.css";
import { useWindowSize } from "../../utils/hooks";
const getProps = (data) => {
    const desktopBanner = Fold.preview(_DesktopBanner, data);
    const mobileBanner = Fold.preview(_MobileBanner, data);
    const bannerLinkM = Fold.preview(_BannerLink, data);
    const bannnerLink = M.fromMaybe(bannerLinkM, "");
    return { desktopBanner, mobileBanner, bannnerLink };
};
const PromotionalBanner = ({ desktopBanner, mobileBanner, bannnerLink, }) => {
    const [width] = useWindowSize();
    const imageSrcM = width && width <= 699 ? mobileBanner : desktopBanner;
    const imageWidth = width && width <= 699 ? 800 : 1400;
    return (React.createElement(React.Suspense, { fallback: () => React.createElement(React.Fragment, null) },
        React.createElement("div", { className: styles.wrapper }, bannnerLink ? (React.createElement(Link, { href: bannnerLink },
            React.createElement(RenderMaybe, null, M.map((image) => (React.createElement(SonicImageDplus, { src: image.src, quality: 75, className: styles.banner, width: imageWidth })), imageSrcM)))) : (React.createElement(RenderMaybe, null, M.map((image) => (React.createElement(SonicImageDplus, { src: image.src, quality: 75, className: styles.banner, width: imageWidth })), imageSrcM))))));
};
export const ComponentMapItem = mkSiteBuilderComponent(getProps, PromotionalBanner);

